import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { onGetSettingsRequest } from "../../../Stores/AuthSlice";
import { getCyclesState, getVendorState } from "../../../Stores/CycleSlice";
import { createKeyRequest, getKeysState } from "../../../Stores/KeySlice";
import { getVoucherRequest, getVoucherState } from "../../../Stores/VoucherSlice";

const ModalPackage = ({ isOpen, onClose, id, lang, type }) => {
    const cyclesData = useSelector(getCyclesState);
    const keysData = useSelector(getKeysState);
    const voucherData = useSelector(getVoucherState);
    const [dataPackage, setDataPackage] = useState([]);
    const [numberKey, setNumberKey] = useState(1);
    const [numberCycle, setNumberCycle] = useState(1);
    const [cycleSelected, setCycleSelected] = useState("");
    const [cycleSelectedPrice, setCycleSelectedPrice] = useState(0);
    // Voucher
    const [codeVoucher, setCodeVoucher] = useState("");
    const [isCheckVoucher, setIsCheckVoucher] = useState(false);
    const [discountPercent, setDiscountPercent] = useState(null);
    // unit selected
    const [unitSelected, setUnitSelected] = useState(null);
    // vendor selected
    const [vendorSelected, setVendorSelected] = useState("");
    const dispath = useDispatch();
    const navigate = useNavigate();
    const vendor = useSelector(getVendorState)

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if(cyclesData){
            setDataPackage(cyclesData.filter((data) => (data.package_id === id)))
        }
    }, [id, cyclesData])

    useEffect(() => {
        if (dataPackage[0]) {
            setCycleSelected(dataPackage[0].id)
            setCycleSelectedPrice(dataPackage[0].price)
            setUnitSelected(translate_unit(dataPackage[0].unit))
            setVendorSelected('all')
        }
    }, [dataPackage])

    useEffect(() => {
        if(voucherData) {
            switch (voucherData.type) {
                case "percent":
                    setDiscountPercent(voucherData.value)
                    break;
            
                default:
                    break;
            }
        }
    }, [voucherData])

    const translate_unit = (unit) => {
        switch (unit) {
            case "day":
                return lang.day;
            case "week":
                return lang.week;
            case "month":
                return lang.month;
        }
    }

    const changeNumberKey = ({ type, value }) => {
        switch (type) {
            case "+":
                setNumberKey(numberKey + value)
                break;
            case "-":
                if (numberKey > 1) {
                    setNumberKey(numberKey - value)
                }
                break;

            default:
                if (value > 0) {
                    setNumberKey(value)
                }
                break;
        }
    }

    const changeNumberCycle = ({ type, value }) => {
        switch (type) {
            case "+":
                setNumberCycle(numberCycle + value)
                break;
            case "-":
                if (numberCycle > 1) {
                    setNumberCycle(numberCycle - value)
                }
                break;

            default:
                if (value > 0) {
                    setNumberCycle(value)
                }
                break;
        }
    }

    const changeOptionCycle = (e) => {
        setCycleSelected(e.target.value)
        setCycleSelectedPrice(parseInt(e.target[e.target.selectedIndex].getAttribute("price")))
        setUnitSelected(translate_unit(e.target[e.target.selectedIndex].getAttribute("unit")))
    }

    const changeVendor = (e) => {
        setVendorSelected(e.target.value);
    }

    const onSubmitOrder = () => {
        setIsLoading(true)
        const dataOrder = {
            quantity: numberKey,
            number_cycles: numberCycle,
            cycle_id: cycleSelected,
            voucher: codeVoucher,
            vendor: vendorSelected,
        }
        dispath(createKeyRequest(dataOrder)).then((response) => {
            setIsLoading(false)
            if (response.payload.message) {
                dispath(onGetSettingsRequest())
                // Success
                toast.success(response.payload.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate('/key');
            }
        })
    }

    const onUseVoucher = () => {
        if(codeVoucher) {
            setIsCheckVoucher(true)
            dispath(getVoucherRequest(codeVoucher)).then((res) => {
                setIsCheckVoucher(false)
            })
        }
    }


    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-screen-md p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl"
                >
                    &times;
                </button>

                {/* Modal Title */}
                <h2 className="text-xl font-semibold mb-6 text-center">{lang.order_new_key || <span>Đặt hàng key mới</span>}</h2>

                {/* Quantity of Keys */}
                <div className="flex mb-4">
                    <div className="w-2/4">
                        <label className="block text-gray-700 text-sm font-medium mb-1">{lang.number_of_keys || <span>Số lượng key *</span>}</label>
                        <div className="flex items-center">
                            <button onClick={() => changeNumberKey({ type: "-", value: 1 })} className="px-3 py-1 h-10 border border-gray-300 rounded-l text-gray-600">-</button>
                            <input
                                type="text"
                                className="w-full h-10 text-center border-t border-b border-gray-300"
                                value={numberKey}
                                readOnly
                            />
                            <button onClick={() => changeNumberKey({ type: "+", value: 1 })} className="px-3 py-1 h-10 border border-gray-300 rounded-r text-gray-600">+</button>
                        </div>
                    </div>
                    {type !== "pc" && (
                        <div className="w-2/4 ml-4">
                            <label className="block text-gray-700 text-sm font-medium mb-1">{lang.vendor || <span>Nhà cung cấp *</span>}</label>
                            <select onChange={changeVendor} className="w-full border border-gray-300 rounded px-3 py-2 h-10">
                                <option key='all' value='all'>Tất cả</option>
                                {/* {
                                Object.entries(vendor).map(([key, value]) => {
                                        return <option key={key} value={value}>{key}</option>
                                })} */}
                            </select>
                        </div>
                    )}
                </div>

                {/* Package Cycle Selection */}
                <div className="flex mb-4">
                    <div className="w-2/4">
                        <label className="block text-gray-700 text-sm font-medium mb-1">{lang.package_period || <span>Thời gian gói *</span>}</label>
                        <select onChange={changeOptionCycle} className="w-full border border-gray-300 rounded px-3 py-2 h-10">
                            {dataPackage.map((data) => {
                                return <option key={data.id} value={data.id} price={data.price} unit={data.unit}>{data.name}</option>
                            })}
                        </select>
                        {/* <p className="text-sm text-emerald-500 mt-1">Giá theo ngày: 4,000</p> */}
                    </div>

                    {/* Number of Cycles */}
                    <div className="w-2/4 ml-4">
                        <label className="block text-gray-700 text-sm font-medium mb-1">{lang.number_of_periods.replace("##UNIT##", unitSelected) || <span>Số lượng chu kỳ *</span>}</label>
                        <div className="flex items-center">
                            <button onClick={() => changeNumberCycle({ type: "-", value: 1 })} className="px-3 py-1 h-10 border border-gray-300 rounded-l text-gray-600">-</button>
                            <input
                                type="text"
                                className="w-full h-10  text-center border-t border-b border-gray-300"
                                value={numberCycle}
                                readOnly
                            />
                            <button onClick={() => changeNumberCycle({ type: "+", value: 1 })} className="px-3 py-1 h-10 border border-gray-300 rounded-r text-gray-600">+</button>
                        </div>
                    </div>

                </div>

                {/* Discount Code */}
                <div className="flex mb-4">
                    <div className="w-full">
                        <label className="block text-gray-700 text-sm font-medium mb-1">{lang.discount || <span>Mã giảm giá</span>}</label>
                        <div className="flex">
                            <div className="w-7/12">
                                <input
                                    type="text"
                                    placeholder="Nhập Mã giảm giá"
                                    className="w-full h10 border border-gray-300 rounded-l px-3 py-2"
                                    value={codeVoucher}
                                    onChange={(e) => setCodeVoucher(e.target.value)}
                                />
                            </div>
                            <div className="w-5/12 flex justify-center">
                                <button onClick={onUseVoucher} className="w-3/4 px-4 py-2 bg-emerald-500 text-white rounded">{isCheckVoucher ? "Đang kiểm tra mã" :"Áp Dụng Mã Giảm Giá"}</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Pricing Details */}
                <div className="grid-cols-2 gap-2 text-sm text-gray-700 mb-6">
                    <div className="flex justify-between">
                        {lang.price || <span>Giá</span>}
                        <span>{cycleSelectedPrice.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                        {lang.number_of_periods.replace("##UNIT##", unitSelected) || <span>Số lượng chu kỳ</span>}
                        <span>{numberCycle}</span>
                    </div>
                    <div className="flex justify-between">
                        {lang.number_of_keys || <span>Số lượng</span>}
                        <span>{numberKey}</span>
                    </div>
                    <div className="flex justify-between">
                        {lang.original_price || <span>Giá gốc</span>}
                        <span>{(cycleSelectedPrice * numberCycle * numberKey).toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                        {lang.discount || <span>Giá được giảm</span>}
                        <span>
                            {discountPercent ? <span>- {(cycleSelectedPrice * numberCycle * numberKey * discountPercent/100).toLocaleString()}</span> : 0}
                        </span>
                    </div>
                    <div className="col-span-2 flex justify-between font-semibold border-t pt-2 mt-2">
                        {lang.total || <span>Tổng</span>}
                        <span>{(cycleSelectedPrice * numberCycle * numberKey - (cycleSelectedPrice * numberCycle * numberKey * discountPercent/100)).toLocaleString()}</span>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-center space-x-2">
                    {isLoading ?
                        <button
                            className="flex justify-center items-center pointer-events-none px-4 py-2 bg-emerald-500 text-white rounded"
                        >
                            <svg aria-hidden="true" role="status" className="inline w-4 h-4 me-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                            </svg>
                            Đang Đặt Hàng...
                        </button>
                        : <>
                            <button
                                onClick={onClose}
                                className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
                            >
                                {lang.cancel || <span>Hủy</span>}
                            </button>
                            <button
                                onClick={onSubmitOrder}
                                className="px-4 py-2 bg-emerald-500 text-white rounded"
                            >
                                {lang.order || <span>Đặt Hàng</span>}
                            </button>
                        </>}
                </div>
            </div>
        </div>
    );
}

export default ModalPackage